/**
 * 사진 업로드 영역(.uploader).
 *
 * 끌어다 놓기를 직접 받는다. 처리하지 않으면 브라우저가 그 파일을 창에 열어 버려서
 * 입력하던 폼 내용이 통째로 날아간다 — 영역 밖에 떨어뜨린 경우까지 막아 둔다.
 *
 * 고른 파일은 input.files 에 넣고 change 를 흘려보내므로, 폼 전송이나 미리보기 같은
 * 뒷단 처리는 평소처럼 input 만 보면 된다.
 */

import { guardWindowDrop } from './dropGuard';

const InitUploader = () => {
  const uploaders = document.querySelectorAll('.uploader');

  if (0 === uploaders.length) {
    return;
  }

  guardWindowDrop('.uploader');

  uploaders.forEach((uploader) => {
    const input = uploader.querySelector('.uploader__input');
    const zone = uploader.querySelector('.uploader__zone');
    const desc = uploader.querySelector('.uploader__desc');

    if (!input || !zone) {
      return;
    }

    const defaultDesc = desc?.textContent || '';

    const showName = () => {
      if (!desc) {
        return;
      }

      const file = input.files?.[0];

      desc.textContent = file ? file.name : defaultDesc;
    };

    const over = (event) => {
      event.preventDefault();
      zone.classList.add('uploader__zone--over');
    };

    const leave = () => zone.classList.remove('uploader__zone--over');

    zone.addEventListener('dragenter', over);
    zone.addEventListener('dragover', over);
    zone.addEventListener('dragleave', leave);

    zone.addEventListener('drop', (event) => {
      event.preventDefault();
      leave();

      const file = event.dataTransfer?.files?.[0];

      if (!file) {
        return;
      }

      // input.files 는 직접 못 넣으므로 DataTransfer 를 거친다
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    input.addEventListener('change', showName);
    showName();
  });
};

export default InitUploader;
